import type { Security } from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import type { SecuritySchemaMergedState } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { selectReferencedTestScope } from 'components/SecuritySchema/model/selectors/selectReferencedTestScope';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectActiveReferencedTest: (
  s: SecuritySchemaMergedState,
) => Security.Test | null = createScopedSelector(() =>
  createSelector(
    prop('deviceSecurity'),
    selectReferencedTestScope,
    (deviceSecurity, scope) =>
      scope !== null
        ? (deviceSecurity?.objects?.namedTests?.[scope.name] ?? null)
        : null,
  ),
);
